import React, { useState } from "react";
import "../Assets/css/login.css"; // Reuse login CSS
import axiosUserInstance from "../axiosUserInstance";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";
import BgVideo from "../Assets/video/login-signup-bg.mp4";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [muted, setMuted] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  // Validate email with regex
  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEmailError("");

    if (!email) {
      setEmailError("Email is required.");
      return;
    } else if (!validateEmail(email)) {
      setEmailError("Please enter a valid email.");
      return;
    }

    setIsLoading(true);

    try {
      const response = await axiosUserInstance.post(`/user/forgotPassword`, {
        email,
      });
      if (response?.status === 200) {
        toast.success(
          "Password reset email sent successfully. Please check your inbox."
        );
        setEmail(""); // clear the email
      } else {
        toast.error(
          response?.message || "Failed to send reset email. Please try again."
        );
      }
    } catch (err) {
      const apiError =
        err?.response?.data?.message ||
        err?.message ||
        "An error occurred. Please try again.";
      toast.error(apiError);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      {/* Background Video */}
      <video
        autoPlay
        loop
        muted={muted}
        playsInline
        className="video-background"
        id="bgVideo"
      >
        <source src={BgVideo} type="video/mp4" />
      </video>

      {/* Toggle Button */}
      <button className="audio-toggle" onClick={() => setMuted(!muted)}>
        <i className={`fas ${muted ? "fa-volume-mute" : "fa-volume-up"}`}></i>
      </button>

      {/* Forgot Password Box */}
      <div className="login-container">
        <div className="login-header">
          <h1>Forgot Password</h1>
          <p>Enter your email to receive a password reset link.</p>
        </div>

        <div className="login-form">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                className="form-control"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {emailError && <div className="error-message">{emailError}</div>}
            </div>

            <Button
              className="btn btn-primary"
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? "Sending…" : "Send Reset Link"}
            </Button>

            <div className="divider">or</div>

            <div className="login-footer">
              Remembered your password? <Link to={"/auth/login"}>Login</Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
